<template>
  <div>
    <section class="hero is-medium is-white">
    <div class="hero-head">
        <nav class="navbar">
          <div class="container">
            <div class="navbar-brand">
              <a class="navbar-item">
                  <img src="../assets/logo.png" alt="Logo" >
                  <h2 style="margin-left:10px;font-weight: bold; font-size: 18px;">Leita</h2>
              </a>
            </div>
            <div id="navbarMenuHeroA" class="navbar-menu">
              <div class="navbar-end">
                  <a class="navbar-item is-active">
                    iOS
                  </a>
                  <a class="navbar-item" href="https://chrome.google.com/webstore/detail/leita-extension/galigneggpjdojmmaphdmnipndgdgabd?hl=ja" target="blank">
                    Chrome Extension
                  </a>
                  <span class="navbar-item">
                    <a class="button is-inverted" href="https://itunes.apple.com/jp/app/id1449226632" target="blank">
                      <span>iOS App</span>
                    </a>
                  </span>
                  <span class="navbar-item" style="margin-left:0px">
                    <a class="button is-inverted" href="/login" style="width:90px">
                      <span>Login</span>
                    </a>
                  </span>
                </div>
              </div>
            </div>
        </nav>
    </div>
    

    <div class="hero-body">
      <div class="columns">
        <div class="column" style="padding-left:0px">
          <div style="">
            <p class="title">
              Leita <br class="br-sp">自動分類ブラウザ
            </p>
            <p class="subtitle">
              かしこく、タブを管理    
            </p>
            <a href="https://itunes.apple.com/jp/app/id1449226632" target="_blank">
              <img src="../assets/appstore.svg" >
            </a>
            <br>
            <a href="/login" class="button is-normal" style="margin-top:10px; width:120px">Login</a>
          </div>
        </div>
        <!-- <div class="column">
          <img src="../assets/logo.png">
        </div> -->
      </div>
    </div>
        
    </section>

    <section class="hero">
        <div class="hero-body" style="padding-bottom: 0">
            <div class="container has-text-centered" style="padding-bottom: 0">
            <p class="title">
                タブを自動分類
            </p>
            <p class="subtitle">
              自動でタグ付けを行います。
            </p>
            <img src="../assets/ios1.png">
            </div>
        </div>
    </section>

    <section class="hero is-white">
        <div class="hero-body" style="padding-bottom: 0">
            <div class="container has-text-centered" style="padding-bottom: 0">
            <p class="title">
                タブをTodoアプリのように管理
            </p>
            <p class="subtitle">
              スワイプでサクサク管理
            </p>
            <img src="../assets/ios2.png">
            </div>
        </div>
    </section>

    <section class="hero">
      <div class="hero-body">
          <div class="container has-text-centered">
          <p class="title">
            他のアプリから<br class="br-sp">保存できます。
          </p>
          <p class="subtitle">
            気になった記事をストック。
          </p>
          <img src="../assets/ios3.png">
          </div>
      </div>
    </section>

    <section class="hero is-white">
      <div class="hero-body">
          <div class="container has-text-centered">
          <p class="title">
            PCからでも
          </p>
          <p class="subtitle">
            クラウドシンクで、<br class="br-sp">リアルタイム連携。
          </p>
          <img src="../assets/leita_web.png">
          </div>
      </div>
    </section>

    <section class="hero">
      <div class="hero-body">
          <div class="container has-text-centered">
          <p class="title">
            Chrome Extension
          </p>
          <p class="subtitle">
            自動分類で、<br class="br-sp">らくらくストック。
          </p>
          <img src="../assets/leita_ex.png">
          </div>
      </div>
    </section>

    <section class="hero is-white" style="padding: 100px 0px">
        <div class="hero-body">
            <div class="container has-text-centered">
            <p class="title">
              Let's start!
            </p>
            <a href="https://itunes.apple.com/jp/app/id1449226632" target="_blank">
              <img src="../assets/appstore.svg" >
            </a>
            
            </div>
        </div>
    </section>

    <!-- <footer class="footer">
        <div class="content has-text-centered">
        </div>
    </footer> -->
  </div>
</template>

<script>
export default {
	name: 'ios',
};
</script>

<style lang="scss" scoped>
.is-white {
    background-color:#fcfcfc !important;
}

.title, .subtitle {
  letter-spacing: 0.1em;
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Yu Gothic", YuGothic, Verdana, Meiryo, "M+ 1p", sans-serif;
}

.title {
 opacity: 0.85;
}

@media screen and (min-width: 650px){	
  .br-pc { display:block; }
  .br-sp { display:none; }
}
@media screen and (max-width: 650px){	
  .br-pc { display:none; }
  .br-sp { display:block; }
}

</style>

